<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          Документы <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Новый документ
          <i v-on:click="newObj" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="true" :hide-pages="true" :page-limits="pageLimits" :tuning="false"
             :new-one="newOne"
             :default-sort="'date'" :default-sort-direction="false"
             @resetNew="newOne = null"></big-one>
  </div>
</template>
<script>

import {
  BaseInput,
  Card
} from "@/components/index";

import {sorter} from "@/services/utils";
import {authHeader} from "@/services/auth-header";
import {userService} from "@/services/user.service";

const documentName = {header: "Наименование", name: "name", show: true, sort: true, direction: true}
const creationDate = {header: "Дата создания", name: "date", show: true, sort: true, direction: true}
const documentType = {header: "Тип документа", name: "pattern.name", show: true}

export default{
  name: 'client-call-history',
  components:{
    Card,
    BaseInput
  },
  props:{
    item: {},
    parent: {}
  },
  data() {
    return {
      content: [documentName, creationDate, documentType],
      type: "document",
      pageLimits: {client: this.item.id},
      newOne: null
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    newObj() {
      let currentTime = new Date().getTime();
      let object = {id: 0, date: currentTime, ownerId: this.parent.type + '-' + this.item.id, fields: []};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  }
}
</script>
<style>
</style>
